<script lang="ts" setup>
const { trackEvent } = useCnzz()
const { t, tm, rt } = useI18n()

definePageMeta({ layout: 'page' })

useHead({
  title: t('product1000Shanhai.pageTitle'),
  meta: [
    {
      name: 'description',
      content: t('product1000Shanhai.seo.description'),
    },
  ],
})

// 滚动淡入动画
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px',
}

// 运算模式数据
const operationModes = computed(() => [
  {
    id: '1000s',
    name: t('product1000Shanhai.modes.items.1000s.name'),
    descLines: (
      tm('product1000Shanhai.modes.items.1000s.descLines') as any[]
    ).map((item) => rt(item)),
    highlightValue: t('product1000Shanhai.modes.items.1000s.highlightValue'),
    highlightLabel: t('product1000Shanhai.modes.items.1000s.highlightLabel'),
  },
  {
    id: '1000p',
    name: t('product1000Shanhai.modes.items.1000p.name'),
    descLines: (
      tm('product1000Shanhai.modes.items.1000p.descLines') as any[]
    ).map((item) => rt(item)),
    highlightValue: t('product1000Shanhai.modes.items.1000p.highlightValue'),
    highlightLabel: t('product1000Shanhai.modes.items.1000p.highlightLabel'),
  },
  {
    id: '1000e',
    name: t('product1000Shanhai.modes.items.1000e.name'),
    descLines: (
      tm('product1000Shanhai.modes.items.1000e.descLines') as any[]
    ).map((item) => rt(item)),
    highlightValue: t('product1000Shanhai.modes.items.1000e.highlightValue'),
    highlightLabel: t('product1000Shanhai.modes.items.1000e.highlightLabel'),
  },
])

const activeMode = ref(0)
const showConsultationDialog = ref(false)
const router = useRouter()
const callme = () => {
  showConsultationDialog.value = true
  trackEvent('硬件产品', '点击', '联系我们按钮')
}
// L2 级智能控制数据
const l2ControlFeatures = computed(() => [
  {
    title: t('product1000Shanhai.l2Control.features.0.title'),
    desc: t('product1000Shanhai.l2Control.features.0.desc'),
    icon: 'https://images-cloud.qboson.com/website/shanhai1000/one.png',
  },
  {
    title: t('product1000Shanhai.l2Control.features.1.title'),
    desc: t('product1000Shanhai.l2Control.features.1.desc'),
    icon: 'https://images-cloud.qboson.com/website/shanhai1000/two.png',
  },
  {
    title: t('product1000Shanhai.l2Control.features.2.title'),
    desc: t('product1000Shanhai.l2Control.features.2.desc'),
    icon: 'https://images-cloud.qboson.com/website/shanhai1000/three.png',
  },
])

onMounted(() => {
  const sections = document.querySelectorAll('.fade-in-section')

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-visible')
        const items = entry.target.querySelectorAll('.fade-in-item')
        items.forEach((item) => {
          item.classList.add('fade-in-item-visible')
        })
        observer.unobserve(entry.target)
      }
    })
  }, observerOptions)

  sections.forEach((section) => {
    observer.observe(section)
  })
  trackEvent('硬件产品', '访问', '驭量·山海1000专用量子计算机页')
})
</script>

<template>
  <div class="min-h-screen w-full bg-white font-sans overflow-hidden">
    <!-- Web 端 -->
    <div class="hidden md:block">
      <!-- Hero Section -->
      <section
        class="w-full pt-[80px] md:pt-[120px] pb-[60px] md:pb-[70px] flex flex-col items-center fade-in-section relative"
      >
        <h1
          class="text-[32px] md:text-[48px] font-medium gradient-text text-center px-[20px]"
        >
          {{ t('product1000Shanhai.hero.title') }}
        </h1>
        <p
          class="bg-[rgba(0,0,0,0.02)] text-[16px] md:text-[16px] text-[#000] leading-[26px] md:leading-[26px] text-center max-w-[818px] mb-[40px] md:mb-[50px] p-[10px]"
        >
          {{ t('product1000Shanhai.hero.descMobile') }}
          <!-- <span class="text-[20px] font-bold">{{
            t('product1000Shanhai.hero.desc2')
          }}</span>
          {{ t('product1000Shanhai.hero.desc3') }}
          <br class="hidden md:block" />
          {{ t('product1000Shanhai.hero.desc4') }} -->
        </p>

        <!-- Machine Image Placeholder -->
        <div
          class="w-full max-w-[1200px] h-[250px] md:h-[378px] flex items-center justify-center mb-[40px] md:mb-[30px] relative px-[20px]"
        >
          <!-- 机器图片占位 -->
          <img
            src="https://images-cloud.qboson.com/website/shanhai1000/shanhai.png"
            alt="山海1000"
            class="object-contain w-full h-full relative z-10"
          />
          <!-- 机器底部椭圆形阴影效果 -->
          <div
            class="absolute left-1/2 -translate-x-1/2 bottom-[10px] md:bottom-[130px] w-[100%] h-[30px] md:h-[40px] machine-shadow z-0"
          ></div>
        </div>

        <!-- Buttons -->
        <div class="flex gap-[20px] md:gap-[30px]">
          <button
            class="w-[120px] md:w-[144px] h-[40px] md:h-[48px] rounded-[12px] flex items-center justify-center text-[#333] text-[14px] md:text-[16px] font-medium cursor-pointer gradient-border hover:opacity-80 transition-opacity bg-white"
            @click="callme"
          >
            {{ t('product1000Shanhai.hero.btnContact') }}
          </button>
          <button
            class="w-[120px] md:w-[144px] h-[40px] md:h-[48px] rounded-[12px] flex items-center justify-center text-[#333] text-[14px] md:text-[16px] font-medium cursor-pointer gradient-border hover:opacity-80 transition-opacity bg-white"
            @click="router.push('/product/productSpecs')"
          >
            {{ t('product1000Shanhai.hero.btnCompare') }}
          </button>
        </div>
      </section>

      <!-- 运算模式 Section -->
      <section
        class="w-full relative h-[500px] md:h-[600px] text-white fade-in-section overflow-hidden bg-[#0A1628]"
      >
        <!-- Background Image Placeholder -->
        <div class="absolute inset-0 z-0">
          <!-- 此处替换为长城/古建筑星空背景图 -->
          <img
            src="https://images-cloud.qboson.com/website/shanhai1000/shanhaiguan.png"
            alt=""
            class="w-full h-full object-cover opacity-60 bg-[#0c1a2c]"
          />
        </div>

        <div
          class="md:max-w-[1200px] mx-auto relative z-10 h-full flex flex-col justify-center"
        >
          <h2
            class="text-[28px] md:text-[36px] font-medium mb-[20px] md:mb-[24px]"
          >
            {{ t('product1000Shanhai.modes.title') }}
          </h2>
          <p
            class="text-[14px] md:text-[18px] leading-[24px] md:leading-[32px] mb-[30px] md:mb-[40px] text-gray-200 max-w-[400px]"
          >
            <template
              v-for="(line, index) in operationModes[activeMode].descLines"
              :key="index"
            >
              {{ line
              }}<br
                v-if="index < operationModes[activeMode].descLines.length - 1"
              />
            </template>
          </p>

          <!-- 这部分先注释（需要放的话，这个综合求解性能评分的评分标准可能需要备注一下） -->
          <!-- <div class="mb-[60px] inline-block">
            <div
              class="text-[36px] md:text-[48px] font-bold leading-none mb-[8px] md:mb-[10px] md:border-b-[1px] md:border-b-[rgba(255,255,255,0.5)] inline-block pb-[15px]"
            >
              {{ operationModes[activeMode].highlightValue }}
              <span
                v-if="operationModes[activeMode].id !== '1000s'"
                class="text-[36px]"
                >Bit</span
              >
            </div>
            <div class="text-[14px] md:text-[16px] text-gray-300">
              {{ operationModes[activeMode].highlightLabel }}
            </div>
          </div> -->
        </div>
        <!-- Bottom Tabs -->
        <div
          class="absolute bottom-0 left-0 z-10 w-full flex justify-center bg-[#146AA866]"
        >
          <div class="flex overflow-x-auto">
            <div
              v-for="(mode, index) in operationModes"
              :key="mode.id"
              class="w-[400px] text-center text-[#fff] py-[16px] md:py-[24px] text-[16px] md:text-[18px] font-medium cursor-pointer whitespace-nowrap relative transition-colors"
              @click="activeMode = index"
            >
              {{ mode.name }}
              <div
                v-if="activeMode === index"
                class="absolute top-0 left-0 w-full h-[4px]"
                style="
                  background: linear-gradient(
                    67deg,
                    #37beef 33.51%,
                    #47b897 100%
                  );
                "
              ></div>
            </div>
          </div>
        </div>
      </section>

      <!-- 端到端计算时间更短 -->
      <section
        class="w-full bg-[#fff] py-[60px] md:h-[557px] flex items-center justify-center fade-in-section"
      >
        <div
          class="max-w-[1200px] w-full flex items-center justify-between gap-[167px]"
        >
          <!-- 左侧文字区域 -->
          <div class="flex flex-col items-start w-[450px]">
            <h2 class="text-[36px] font-medium mb-[20px] text-[#000]">
              {{ t('product1000Shanhai.speed.titleWeb') }}
            </h2>
            <div
              class="text-[43px] font-bold gradient-text"
              style="text-align: left"
            >
              {{ t('product1000Shanhai.speed.highlight') }}
            </div>
          </div>

          <!-- 右侧图片区域 -->
          <div class="w-full h-[440px] flex-1 flex justify-end">
            <img
              src="https://images-cloud.qboson.com/website/shanhai1000/shandian.gif"
              alt="端到端计算时间更短"
              class="w-full h-full object-contain"
            />
          </div>
        </div>
      </section>

      <!-- L2 级智能控制 -->
      <section
        class="w-full bg-[#F7F9FD] py-[60px] md:py-[100px] fade-in-section"
      >
        <div class="max-w-[1200px] mx-auto">
          <h2
            class="text-[28px] md:text-[36px] font-medium mb-[40px] md:mb-[80px] text-center text-[#000]"
          >
            {{ t('product1000Shanhai.l2Control.title') }}
          </h2>

          <div
            class="flex flex-col-reverse md:flex-row justify-between items-center gap-[40px] md:gap-[238px]"
          >
            <!-- Left side list -->
            <div
              class="flex flex-col gap-[20px] md:gap-[20px] w-full md:w-[530px]"
            >
              <div
                v-for="(feature, index) in l2ControlFeatures"
                :key="index"
                class="bg-white p-[20px] md:p-[40px] rounded-xl shadow-[4px_4px_12px_0px_rgba(87,126,211,0.08)] border border-[#EEEEEE] flex items-center gap-[16px] md:gap-[20px] hover:-translate-y-1 transition-transform"
              >
                <!-- 图标占位 -->
                <img
                  :src="feature.icon"
                  class="w-[68px] h-[68px] object-contain"
                  alt="icon"
                />
                <div>
                  <h3
                    class="text-[16px] md:text-[20px] font-medium mb-[8px] md:mb-[12px] text-[#000]"
                  >
                    {{ feature.title }}
                  </h3>
                  <p
                    class="text-[12px] md:text-[16px] text-[#666666] leading-[20px] md:leading-[26px]"
                  >
                    {{ feature.desc }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Right side image -->
            <div
              class="bg-[#fff] rounded-[12px] shadow-[4px_4px_12px_0px_rgba(87,126,211,0.08)] w-full md:w-[481px] md:h-[483px] flex items-center justify-center relative"
            >
              <img
                src="https://images-cloud.qboson.com/website/shanhai1000/_1000_T_6.gif"
                alt=""
                class="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- 可靠性进一步升级 -->
      <section class="w-full bg-[#FFF] py-[60px] md:py-[80px] fade-in-section">
        <div class="max-w-[1200px] mx-auto">
          <h2
            class="text-[28px] md:text-[36px] font-medium mb-[40px] md:mb-[80px] text-center text-[#000]"
          >
            {{ t('product1000Shanhai.reliability.title') }}
          </h2>

          <div
            class="flex flex-col md:flex-row justify-between items-center gap-[40px] md:gap-[120px]"
          >
            <!-- Left side -->
            <div class="w-full md:w-[300px] text-center md:text-left">
              <div
                class="text-[14px] md:text-[20px] text-[#676767] mb-[16px] md:mb-[24px]"
              >
                {{ t('product1000Shanhai.reliability.serviceDuration.label') }}
              </div>
              <div
                class="text-[48px] md:text-[70px] font-medium mb-[16px] md:mb-[20px] leading-none md:border-b-[1px] md:border-b-[#DAE0ED] md:pb-[20px]"
              >
                <span
                  class="text-[18px] md:text-[70px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                  >{{
                    t('product1000Shanhai.reliability.serviceDuration.value')
                  }}</span
                >
                <span
                  class="text-[18px] md:text-[20px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                  >{{
                    t('product1000Shanhai.reliability.serviceDuration.unit')
                  }}</span
                >
              </div>
              <div class="text-[14px] md:text-[20px] text-[#000]">
                {{ t('product1000Shanhai.reliability.serviceDuration.desc') }}
              </div>
            </div>

            <!-- Center Image -->
            <div
              class="w-[200px] h-[200px] md:w-[420px] md:h-[420px] flex items-center justify-center relative flex-shrink-0"
            >
              <!-- 时钟占位图 -->
              <img
                src="https://images-cloud.qboson.com/website/shanhai1000/time.gif"
                class="w-full h-full object-contain"
                alt="可靠性"
              />
            </div>

            <!-- Right side -->
            <!-- <div class="w-full md:w-auto text-center md:text-left"> -->
            <div class="w-[270px]">
              <div
                class="hidden text-[14px] md:text-[20px] text-[#676767] mb-[16px] md:mb-[20px]"
              >
                {{ t('product1000Shanhai.reliability.support.label') }}
              </div>
              <div
                class="hidden text-[48px] md:text-[70px] font-medium mb-[16px] md:mb-[24px] leading-none md:border-b-[1px] md:border-b-[#DAE0ED] md:pb-[20px]"
              >
                <span
                  class="text-[18px] md:text-[70px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                  >{{ t('product1000Shanhai.reliability.support.value') }}</span
                ><span
                  class="text-[18px] md:text-[16px] md:ml-[5px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                  >{{ t('product1000Shanhai.reliability.support.unit') }}</span
                >
              </div>
              <div class="hidden text-[14px] md:text-[20px] text-[#000]">
                {{ t('product1000Shanhai.reliability.support.desc') }}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 移动端 -->
    <div class="block md:hidden">
      <!-- Hero Section -->
      <section
        class="w-full pt-[90px] pb-[44px] flex flex-col items-center fade-in-section relative px-[16px] bg-[#F9FBFF]"
      >
        <!-- Machine Image Placeholder -->
        <div
          class="w-full h-[200px] flex items-center justify-center mb-[46px] relative"
        >
          <!-- 机器图片占位 -->
          <img
            src="https://images-cloud.qboson.com/website/shanhai1000/shanhai.png"
            alt="山海1000"
            class="object-contain w-full h-full relative z-10"
          />
          <!-- 机器底部椭圆形阴影效果 -->
          <div
            class="absolute left-1/2 -translate-x-1/2 bottom-[65px] w-[150%] h-[50px] machine-shadow z-0"
          ></div>
        </div>

        <h1
          class="text-[23px] font-medium text-[#000] text-center mb-[12px] leading-[28px]"
        >
          {{ t('product1000Shanhai.hero.title') }}
        </h1>
        <p class="text-[12px] text-[#666] leading-[20px] text-left mb-[24px]">
          {{ t('product1000Shanhai.hero.descMobile') }}
        </p>

        <!-- Buttons -->
        <div class="flex gap-[8px] w-full justify-start">
          <button
            class="w-[107px] h-[36px] rounded-[6px] flex items-center justify-center text-[#333] text-[14px] font-medium cursor-pointer gradient-border-mobile hover:opacity-80 transition-opacity bg-white"
            @click="router.push('/product/productConsultation')"
          >
            {{ t('product1000Shanhai.hero.btnContact') }}
          </button>
          <button
            class="w-[107px] h-[36px] rounded-[6px] flex items-center justify-center text-[#333] text-[14px] font-medium cursor-pointer gradient-border-mobile hover:opacity-80 transition-opacity bg-white"
            @click="router.push('/product/productSpecs')"
          >
            {{ t('product1000Shanhai.hero.btnCompare') }}
          </button>
        </div>
      </section>

      <!-- 运算模式 Section -->
      <section
        class="w-full h-[336px] relative text-white fade-in-section overflow-hidden bg-[#0A1628]"
      >
        <!-- Background Image Placeholder -->
        <div class="absolute inset-0 z-0">
          <!-- 移动端背景图占位 -->
          <img
            src="https://images-cloud.qboson.com/website/shanhai1000/shanhaiguan-mobile.png"
            alt=""
            class="w-full h-full object-cover opacity-60 bg-[#0c1a2c]"
          />
        </div>

        <div class="relative z-10 pt-[40px] px-[16px]">
          <h2 class="text-[18px] font-medium mb-[13px] text-white">
            {{ t('product1000Shanhai.modes.title') }}
          </h2>
          <p class="text-[12px] leading-[20px] mb-[20px] text-[#FFFFFF]">
            <template
              v-for="(line, index) in operationModes[activeMode].descLines"
              :key="index"
            >
              {{ line
              }}<br
                v-if="index < operationModes[activeMode].descLines.length - 1"
              />
            </template>
          </p>
          
          <!-- 这部分先注释（需要放的话，这个综合求解性能评分的评分标准可能需要备注一下） -->
          <!-- <div class="mb-[30px] inline-block">
            <div
              class="text-[40px] font-bold leading-none mb-[8px] border-b-[1px] border-b-[rgba(255,255,255,0.5)] inline-block pb-[10px]"
            >
              {{ operationModes[activeMode].highlightValue }}
              <span
                v-if="operationModes[activeMode].id !== '1000s'"
                class="text-[24px]"
                >Bit</span
              >
            </div>
            <div class="text-[12px] text-[#fff]">
              {{ operationModes[activeMode].highlightLabel }}
            </div>
          </div> -->
        </div>

        <!-- Bottom Tabs -->
        <div class="absolute bottom-0 left-0 z-10 w-full flex bg-[#146AA866]">
          <div class="flex w-full">
            <div
              v-for="(mode, index) in operationModes"
              :key="mode.id"
              class="flex-1 text-center py-[16px] text-[14px] text-[#FFFFFF] font-medium cursor-pointer relative transition-colors"
              @click="activeMode = index"
            >
              {{ mode.name }}
              <div
                v-if="activeMode === index"
                class="absolute top-0 left-0 w-full h-[3px]"
                style="
                  background: linear-gradient(
                    64deg,
                    #014396 10.26%,
                    #37beef 53.64%,
                    #47b897 100%
                  );
                "
              ></div>
            </div>
          </div>
        </div>
      </section>

      <!-- 端到端计算时间更短 -->
      <section
        class="w-full bg-[#fff] pt-[40px] pb-[44px] px-[16px] flex flex-col items-center fade-in-section"
      >
        <h2 class="text-[20px] font-medium mb-[12px] text-center text-[#000]">
          {{ t('product1000Shanhai.speed.titleMobile') }}
        </h2>
        <div
          class="text-[24px] font-bold gradient-text-mobile mb-[30px] w-full text-center"
        >
          {{ t('product1000Shanhai.speed.highlight') }}
        </div>

        <!-- Wavy Line Image Placeholder -->
        <div class="w-full flex items-center justify-center">
          <img
            src="https://images-cloud.qboson.com/website/shanhai1000/shandian.gif"
            alt=""
            class="w-full max-w-[266px] h-auto object-contain"
          />
        </div>
      </section>

      <!-- L2 级智能控制 -->
      <section
        class="w-full bg-[#F7F9FD] pt-[40px] pb-[24px] px-[16px] fade-in-section"
      >
        <h2 class="text-[16px] font-medium mb-[35px] text-center text-[#000]">
          {{ t('product1000Shanhai.l2Control.title') }}
        </h2>

        <div class="flex flex-col gap-[35px]">
          <!-- Right side image (在移动端排在上面) -->
          <div
            class="w-full h-[215px] flex items-center justify-center relative"
          >
            <img
              src="https://images-cloud.qboson.com/website/shanhai1000/_1000_T_6.gif"
              alt=""
              class="w-full h-full object-contain"
            />
          </div>

          <!-- Left side list (在移动端排在下面) -->
          <div class="flex flex-col gap-[10px] w-full">
            <div
              v-for="(feature, index) in l2ControlFeatures"
              :key="index"
              class="bg-white px-[17px] py-[22px] rounded-[4px] shadow-[4px_4px_12px_0px_rgba(87,126,211,0.08)] flex items-center gap-[18px]"
            >
              <!-- 图标占位 -->
              <img
                :src="feature.icon"
                class="w-[36px] h-[36px] object-contain"
                alt="icon"
              />
              <div class="flex-1">
                <h3 class="text-[14px] font-medium mb-[10px] text-[#000]">
                  {{ feature.title }}
                </h3>
                <p class="text-[12px] text-[#666666]">{{ feature.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 可靠性进一步升级 -->
      <section class="w-full bg-[#FFF] py-[40px] px-[16px] fade-in-section">
        <h2 class="text-[16px] font-medium mb-[30px] text-center text-[#000]">
          {{ t('product1000Shanhai.reliability.title') }}
        </h2>

        <div class="flex flex-col items-center">
          <!-- Center Image (在移动端放在最上面) -->
          <div
            class="w-[200px] h-[200px] flex items-center justify-center relative mb-[30px]"
          >
            <img
              src="https://images-cloud.qboson.com/website/shanhai1000/time.gif"
              class="w-full h-full object-contain"
              alt="可靠性"
            />
          </div>

          <div class="flex w-full justify-between mt-[20px] gap-[60px]">
            <!-- Left side -->
            <div class="flex flex-col items-center flex-1">
              <div class="text-[12px] text-[#000000] mb-[4px]">
                {{ t('product1000Shanhai.reliability.serviceDuration.label') }}
              </div>
              <div
                class="text-[32px] font-medium mb-[10px] leading-none border-b-[1px] border-b-[#DAE0ED] pb-[10px] w-full text-center"
              >
                <span
                  class="text-[40px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                  >{{
                    t('product1000Shanhai.reliability.serviceDuration.value')
                  }}</span
                >
                <br />
                <span
                  class="text-[14px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                >
                  {{
                    t('product1000Shanhai.reliability.serviceDuration.unit')
                  }}</span
                >
              </div>
              <div class="text-[12px] text-[#000000] text-center">
                {{ t('product1000Shanhai.reliability.serviceDuration.desc') }}
              </div>
            </div>

            <!-- Right side -->
            <!-- <div class="flex flex-col items-center flex-1"> -->
            <div class="w-[150px]">
              <div class="hidden text-[12px] text-[#000000] mb-[4px]">
                {{ t('product1000Shanhai.reliability.support.label') }}
              </div>
              <div
                class="hidden text-[32px] font-medium mb-[10px] leading-none border-b-[1px] border-b-[#DAE0ED] pb-[10px] w-full text-center"
              >
                <span
                  class="text-[40px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                  >{{ t('product1000Shanhai.reliability.support.value') }}</span
                >
                <br />
                <span
                  class="text-[14px] ml-[2px]"
                  style="
                    background: linear-gradient(
                      326.7689600936548deg,
                      #014396 0%,
                      #37beef 46%,
                      #47b897 90%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                  "
                >
                  {{ t('product1000Shanhai.reliability.support.unit') }}</span
                >
              </div>
              <div class="hidden text-[12px] text-[#000000] text-center">
                {{ t('product1000Shanhai.reliability.support.desc') }}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 咨询弹窗 -->
    <ConsultationDialog v-model:show="showConsultationDialog" />
  </div>
</template>

<style scoped>
/* 滚动淡入动画 */
.fade-in-section {
  opacity: 0;
  transform: translateY(30px);
  transition:
    opacity 0.8s ease-out,
    transform 0.8s ease-out;
}

.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 渐变文字 */
.gradient-text {
  font-family:
    Source Han Sans SC,
    Source Han Sans SC;
  font-weight: 500;
  font-size: 43px;
  line-height: 65px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  background: linear-gradient(
    326.7689600936548deg,
    #014396 0%,
    #37beef 46%,
    #47b897 90%
  );
  /* background: linear-gradient(326.7689600936548deg, #47B897 0%, #37BEEF 46%, #014396 90%); */
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

/* 渐变文字 */
.gradient-text-mobile {
  font-family:
    Source Han Sans SC,
    Source Han Sans SC;
  font-weight: 500;
  font-size: 20px;
  line-height: 31px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  background: linear-gradient(
    326.7689600936548deg,
    #47b897 0%,
    #37beef 46%,
    #014396 90%
  );
  /* background: linear-gradient(326.7689600936548deg, #47B897 0%, #37BEEF 46%, #014396 90%); */
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

/* 渐变边框圆角 */
.gradient-border {
  position: relative;
  background: #fff;
  z-index: 1;
}

.gradient-border::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 12px;
  background: linear-gradient(90deg, #47b897 0%, #37beef 46%, #014396 90%);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  z-index: -1;
}

/* 渐变边框圆角 */
.gradient-border-mobile {
  position: relative;
  background: #fff;
  z-index: 1;
}

.gradient-border-mobile::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 6px;
  background: linear-gradient(90deg, #47b897 0%, #37beef 46%, #014396 90%);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  z-index: -1;
}

/* 机器底部椭圆形阴影效果 */
.machine-shadow {
  border-radius: 50%;
  background: #fff;
  filter: blur(15px);
  box-shadow:
    0 0 60px 30px rgba(200, 200, 200, 0.4),
    0 0 100px 60px rgba(200, 200, 200, 0.3),
    0 0 140px 90px rgba(200, 200, 200, 0.2);
}
</style>
